import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Context from "../../Context";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import PageContent from "@my-dld/components/PageContent";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import FormSection from "@my-dld/components/Form/FormSection";
import { LoadableDataState, showErrorMessage } from "@my-dld/utils/UIUtils";
import { EjariPropertyType, Lookup, ValidatePropertyRequest } from "@eres/ejari-api/Entity";
import { AlphaSortProcessor, populateLookupOnTo, StateConsumer } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import PickerInput from "@eres/forms-web/PickerInput";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import FormRow from "@eres/forms-web/FormRow";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import EjariApi from "@eres/ejari-api";
import I8N from "@eres/core/dist/I8N";
import TextInputField from "@eres/forms-web/TextInputField";
import NumberDecimalConverter from "@eres/forms/converters/NumberDecimalConverter";
import { CursorPositioner } from "@my-dld/components/Form/CurrencyInput";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import FormAction from "@my-dld/components/Form/FormAction";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { RegisterPropertyRequest, RegisterPropertyResponse } from "../../api/entities";
import { getEjariActiveUserId, getEjariParticipantId, getEjariUserType } from "@10x/sso";
import SuccessPopup from "../components/SuccessPopup";
import { navigateWithInParent, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { switchEjariUserMode } from "@eres/ejari-core/contexts/EjariContext";
import * as AddPropertyAPI from "../../api/api";
import { resetDataForAddMore } from "../../Utils";
import NumericStringConverter from "@eres/forms/converters/NumericStringConverter";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { RenderLoading } from "@my-dld/components/RTRegistration/AddPartyPopup";

interface LookupState {
	usages?: Lookup[];
	types?: Lookup[];
	subTypes?: Lookup[];
}

interface State extends LookupState, LoadableDataState {
	canChange?: boolean;
	propertyType?: Lookup;
	buildingName?: string;
	unitNo?: string;
	villaName?: string;
	areaSize?: string;
	dewaNo?: string;
	isCommon: boolean;
	usage?: Lookup;
	type?: Lookup;
	subType?: Lookup;
	response?: RegisterPropertyResponse;
	isSuccess?: boolean;
	showLoading?: boolean;
}

class AddProperty extends Component<RoutedViewProps, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: RoutedViewProps ) {
		super( props );
		this.state = {
			propertyType: BUILDING_AND_UNIT,
			isCommon: false,
			loadState: "loading",
			errorContainer: {},
		};
	}

	private static validateAddedProperty( response: RegisterPropertyResponse ) {
		const req: ValidatePropertyRequest = {
			ActiveUserID: getEjariActiveUserId(),
			ActiveUserType: getEjariUserType(),
			ManagementCompanyId: 0,
			OwnerParticipantId: getEjariParticipantId()!,
			PropertyId: response.PropertyId!,
			PropertyTypeId: response.PropertyTypeId!,
			HoldType: response.HoldType!,
		};
		return EjariApi.validateProperty( req );
	}

	componentDidMount() {
		if ( localStorage.getItem( "AddPropertyStatus" ) === "done" ) {
			localStorage.removeItem( "AddPropertyStatus" );
			this.addMoreProperties();
		} else if ( this.context ) {
			const { property, propertyType, canChange } = this.context;
			this.setState( {
				canChange: canChange,
				propertyType: propertyType,
				buildingName: I8N.isRTL() ? property?.BuildingNameAr : property?.BuildingNameEn,
			} );
			populateLookupOnTo( EjariLookUp.ALL_PROPERTY_USAGES, StateConsumer( this, "usages" ), undefined, AlphaSortProcessor );
		}
	}

	componentWillUnmount() {
		localStorage.removeItem( "AddPropertyStatus" );
		JQModal( "SuccessPopup" ).hide();
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
		};
		const checkFiledProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
		};
		const { property } = this.context;
		const { canChange, propertyType, usages, types, subTypes, usage, type, isSuccess, showLoading } = this.state;
		return <PageContent title={ Strings.add_your_property } hideQLinks={ true }>
			<PageTitle title={ Strings.add_your_property } paths={ [ DashboardBCItem ] }/>
			<div className="tender-registration-form multi-list-add-container">
				<FormSection title={ this.getTitle() }>
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					<FormRow { ...filedProps }>
						<PickerInput
							required={ true }
							id={ "propertyType" }
							label={ Strings.property_type }
							items={ property ? PropertyTypes2 : PropertyTypes1 }
							toIdentifier={ IdExtractor }
							disabled={ !canChange }/>
					</FormRow>
					{ propertyType?.Id === BUILDING_AND_UNIT.Id && <FormRow { ...filedProps }>
						<TextInputField
							required={ true }
							id={ "buildingName" }
							label={ Strings.building_name }
							maxLength={ 100 }
							disabled={ property !== undefined }
							placeHolder={ Strings.building_name }/>
						<TextInputField
							required={ true }
							id={ "unitNo" }
							label={ Strings.Unit_Number_Label }
							maxLength={ 100 }
							placeHolder={ Strings.Unit_Number_Label }/>
					</FormRow> }
					{ propertyType?.Id === VILLA.Id && <FormRow { ...filedProps }>
						<TextInputField
							required={ true }
							id={ "villaName" }
							label={ Strings.villa_name }
							maxLength={ 100 }
							placeHolder={ Strings.villa_name }/>
					</FormRow> }
					<FormRow { ...filedProps }>
						<TextInputField
							required={ true }
							id={ "areaSize" }
							label={ Strings.area_size_sq_mt }
							valueConverter={ NumberDecimalConverter }
							cursorPositioner={ CursorPositioner }
							placeHolder={ Strings.area_size_sq_mt }/>
						<TextInputField
							required={ true }
							id={ "dewaNo" }
							label={ Strings.dewa }
							valueConverter={ NumericStringConverter }
							maxLength={ 9 }
							placeHolder={ Strings.dewa }/>
						<div className="col-md-4 is-common-container">
							<CheckBoxField
								id={ "isCommon" }
								label={ Strings.is_common }
								labelClassName={ "custom-control-label" }
								{ ...checkFiledProps }/>
						</div>
					</FormRow>
					<FormRow { ...filedProps }>
						<PickerInput
							required={ true }
							id={ "usage" }
							label={ Strings.usage }
							isLoading={ usages === undefined }
							items={ usages }
							toIdentifier={ IdExtractor }
							onValueChange={ this.onChangeUsage }/>
						{ usage && <PickerInput
							required={ true }
							id={ "type" }
							label={ Strings.type }
							isLoading={ types === undefined }
							items={ types }
							toIdentifier={ IdExtractor }
							onValueChange={ this.onChangeType }/> }
						{ type && <PickerInput
							required={ true }
							id={ "subType" }
							label={ Strings.sub_type }
							isLoading={ subTypes === undefined }
							items={ subTypes }
							toIdentifier={ IdExtractor }/> }
					</FormRow>
				</FormSection>
				<FormRow>
					<FormAction
						primaryActionLabel={ Strings.add_property }
						onPrimaryAction={ this.onAddProperty }
						secondaryActionLabel={ Strings.cancel }
						onSecondaryAction={ this.onCancel }
						actionContainerClassName={ "col-md-12" }/>
				</FormRow>
			</div>
			{ isSuccess && <SuccessPopup
				onDismiss={ this.onDismiss }
				onAddMore={ this.onAddMore }
				onCreateContract={ this.onCreateContract }/> }
			{ showLoading && <RenderLoading/> }
		</PageContent>;
	}

	private getTitle() {
		const { property } = this.context;
		const { propertyType } = this.state;
		if ( propertyType?.Id === BUILDING_AND_UNIT.Id ) {
			if ( property )
				return Strings.unit;
			return Strings.building_and_unit;
		} else if ( propertyType?.Id === VILLA.Id ) {
			return Strings.villa;
		}
		return Strings.add_property;
	}

	private onChangeUsage = ( usage?: Lookup ) => {
		const { propertyType } = this.state;
		this.setState( { types: undefined, type: undefined } );
		if ( propertyType && usage ) {
			EjariApi.getPropertyTypes( usage.Id, propertyType.Id ).then( types => {
				types = AlphaSortProcessor( types );
				this.setState( { types: types, loadState: "done" } );
			} );
		}
	};

	private onChangeType = ( type?: Lookup ) => {
		this.setState( { subTypes: undefined, subType: undefined } );
		if ( type ) {
			EjariApi.getPropertySubTypes( type.Id ).then( subTypes => {
				subTypes = AlphaSortProcessor( subTypes );
				this.setState( { subTypes: subTypes } );
			} );
		}
	};

	private onAddProperty = () => {
		if ( this.isValid() ) {
			this.setState( { showLoading: true } );
			const request = this.getRequest();
			AddPropertyAPI.registerProperty( request ).then( ( resp: RegisterPropertyResponse ) => {
				const { searchParams } = this.context;
				const isFromLand = searchParams?.isFromLand;
				resetDataForAddMore( isFromLand );
				addPropertyAnalytics( "SubmitSuccess", resp );
				localStorage.setItem( "AddPropertyStatus", "done" );
				this.setState( {
					showLoading: false,
					isSuccess: true,
					response: resp,
				} );
			} ).catch( e => {
				addPropertyAnalytics( "SubmitFailed" );
				this.setState( { showLoading: false } );
				showErrorMessage( e );
			} );
		}
	};

	private onCancel = () => {
		this.props.history.goBack();
	};

	private isValid() {
		const error: ErrorContainer = {};
		const state = this.state;
		let isValid: boolean = checkNonEmpty( state, "propertyType", error );
		if ( state.propertyType?.Id === BUILDING_AND_UNIT.Id ) {
			isValid = checkNonEmpty( state, "buildingName", error ) && isValid;
			isValid = checkNonEmpty( state, "unitNo", error ) && isValid;
		} else if ( state.propertyType?.Id === VILLA.Id ) {
			isValid = checkNonEmpty( state, "villaName", error ) && isValid;
		}
		isValid = checkNonEmpty( state, "areaSize", error ) && isValid;
		if ( state.areaSize === "0" ) {
			isValid = false;
			error.areaSize = Strings.required;
		}
		isValid = checkNonEmpty( state, "dewaNo", error ) && isValid;
		if ( isValid && state.dewaNo?.length !== 9 ) {
			isValid = false;
			error.dewaNo = Strings.invalid_data;
		}
		isValid = checkNonEmpty( state, "usage", error ) && isValid;
		isValid = checkNonEmpty( state, "type", error ) && isValid;
		isValid = checkNonEmpty( state, "subType", error ) && isValid;
		this.setState( {
			errorContainer: error,
		} );
		return isValid;
	}

	private getRequest(): RegisterPropertyRequest {
		const { searchParams, property } = this.context;
		const state = this.state;
		return {
			ActiveUserID: 0,
			ActiveUserType: getEjariUserType(),
			LandPropertyId: ( searchParams && searchParams.landPropertyId ) ?? 0,
			PropertyTypeId: state.propertyType?.Id,
			BuildingPropertyId: ( property && property.BuildingPropertyId ) ?? 0,
			VillaName: state.villaName ?? "",
			BuildingName: state.buildingName ?? "",
			UnitNumber: state.unitNo ?? "",
			ActualArea: state.areaSize,
			DEWAPremiseNumber: state.dewaNo,
			DEWACommon: state.isCommon,
			EjariPropertyUsageId: state.usage?.Id,
			EjariPropertyTypeId: state.type?.Id,
			EjariPropertySubTypeId: state.subType?.Id,
			OwnersParticipantId: getEjariParticipantId(),
		};
	}

	private onDismiss = () => {
		this.setState( {
			isSuccess: undefined
		}, this.addMoreProperties );
	};

	private onAddMore = () => {
		this.setState( {
			isSuccess: undefined
		}, this.addMoreProperties );
	};

	private addMoreProperties = () => {
		const { searchParams } = this.context;
		const isFromLand = searchParams?.isFromLand;
		let routeName = "search";
		if ( isFromLand ) {
			routeName = "properties";
		}
		replaceNavigate( `/mydld/addproperty/${ routeName }` );
	};

	private onCreateContract = () => {
		const { response } = this.state;
		if ( response ) {
			this.setState( { showLoading: true } );
			AddProperty.validateAddedProperty( response ).then( () => {
				addPropertyAnalytics( "ValidatePropertySuccess", response );
				JQModal( "SuccessPopup" ).hide();
				Promise.all( [
					this.addMoreProperties(),
				] ).then( () => {
					this.setState( { showLoading: false, isSuccess: undefined } );
					switchEjariUserMode( "owner" );
					navigateWithInParent( "mydld",
						`leased/property/${ response.PropertyTypeId }/${ response.PropertyId }/${ response.HoldType === 1 }/${ true }/ejarisvc` );
				} );
			} ).catch( e => {
				addPropertyAnalytics( "ValidatePropertyFailed", response );
				this.setState( { showLoading: false } );
				showErrorMessage( e );
			} );
		}
	};
}

function addPropertyAnalytics( action: string, resp?: RegisterPropertyResponse ) {
	let data: any = { participantId: "" + getEjariParticipantId() };
	if ( resp ) {
		data = {
			...data,
			propertyID: "" + resp.PropertyId,
			ejariPropertyID: "" + resp.EjariPropertyId,
			propertyTypeID: "" + resp.PropertyTypeId,
		};
	}
	trackEventWithData( "AddProperty", action, data );
}

export const BUILDING_AND_UNIT = {
	Id: EjariPropertyType.UNIT,
	...LVStrings.building_and_unit,
};

export const UNIT = {
	Id: EjariPropertyType.UNIT,
	...LVStrings.unit,
};

export const VILLA = {
	Id: EjariPropertyType.VILLA,
	...LVStrings.villa,
};

const PropertyTypes1 = [ BUILDING_AND_UNIT, VILLA ];
const PropertyTypes2 = [ UNIT, VILLA ];
export default AddProperty;
